import React, { useEffect, useState, useContext } from "react";
import Button from "@material-ui/core/Button";
import Axios from "axios";
import Banner from "../Components/Banner";
import Navbar from "../Components/Navbar";
import SimpleTabs from "../Components/Tabs";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import {
  useHistory,
  BrowserRouter,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Page from "../Components/Page";
import Orders from "../Components/Orders";
import Promocodes from "../Components/Promocodes";
import Profile from "../Components/Profile";
import Transactions from "../Components/Transactions";
// import localizations pakeges
import { withTranslation, useTranslation, Trans } from "react-i18next";
import Rewards from "../Components/Rewards";
import { getByDisplayValue } from "@testing-library/dom";
import WalletTab from "../Components/WalletTab";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));
function Dashboard(props) {
  let history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  // const [isLoading, setIsLoading] = useState(true)
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [title, setTitle] = useState(t("dashboard.transactions"));


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    if (newValue == 0) {
      setTitle(t("dashboard.transactions"));
    } else if (newValue == 1) {
      setTitle(t("dashboard.promocodes"));
    } else if (newValue == 2) {
      setTitle(t("dashboard.orders"));
    }else if (newValue == 3) {
      setTitle(t("dashboard.rewards"));
    }else if (newValue == 4) {
      setTitle(t("dashboard.my-profile"));
    } 
    setValue(newValue);
    // console.log(newValue);
  };
  // console.log(value);

  

  const [count, setCount] = useState(0);
  if (!appState.loggedIn) {
    history.push("/");
  }

  // Fetching Data --------------------------------------------------------------------

  //-------- Fetch Complete --------------------------------
  if (appState.loggedIn) {
    // console.log("login he bhai")
    return (
      <>
        {appState.alertMessage ? (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            message={appState.alertMessage.Message}
            open={appState.alertMessage.open}
          />
        ) : (
          <div class="empt"></div>
        )}
        <Navbar handleChange={handleChange} />
        <div className="main_area">
          {/* <div className="col-lg-2 px-1 col-4 text-right">
                                <Button variant="contained" color="primary" aria-controls="simple-menu" className="bg-primary" aria-haspopup="true" onClick={handleClick}>
                                    Sort By
                                </Button>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={handleClose}>Profile</MenuItem>
                                    <MenuItem onClick={handleClose}>My account</MenuItem>
                                    <MenuItem onClick={handleClose}>Logout</MenuItem>
                                </Menu>
                            </div> */}

          <SimpleTabs
            // setTitle={setTitle}
            // title={title}
            // handleChange={handleChange}
            // value={value}
            count={count}
          />

          <div>
            <Switch>
              {appState.loggedIn ? "" : <Redirect to="/" />}
              <Route exact path="/">
                <Page title="Dashboard">
                <Orders setCount={setCount} />
                </Page>
              </Route>
              <Route exact path="/dashboard">
                <Page title="Dashboard">
                <Orders setCount={setCount} />
                </Page>
              </Route>
              <Route exact path={`/dashboard/transactions`}>
                <Transactions setCount={setCount} />
              </Route>
              {/* <Route exact path={`/dashboard/wallet`}>
                <WalletTab />
              </Route> */}
              <Route exact path={`/dashboard/promo`}>
                <Promocodes setCount={setCount} />
              </Route>
              <Route exact path={`/dashboard/profile`}>
                <Profile />
              </Route>
              <Route exact path={`/dashboard/orders`}>
                <Orders setCount={setCount} />
              </Route>
              <Route exact path={`/dashboard/rewards`}>
                <Rewards setValue={setValue} />
              </Route>

              {/* <Route path="/:id" children={<Child />} /> */}
            </Switch>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(Dashboard);
